export interface DatesIntervalType {
  start: string | null;
  end: string | null;
}

export function isDatesIntervalType(value: any): value is DatesIntervalType {
  return value && value.start !== undefined && value.end !== undefined;
}
